import { render, staticRenderFns } from "./section-suggestion.vue?vue&type=template&id=4ce6817c&scoped=true"
import script from "./section-suggestion.vue?vue&type=script&lang=js"
export * from "./section-suggestion.vue?vue&type=script&lang=js"
import style0 from "./section-suggestion.vue?vue&type=style&index=0&id=4ce6817c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce6817c",
  null
  
)

export default component.exports